import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../../../../types/store';
import {
  getCoverDeviation,
  getCoverDeviationOffsetY,
} from '../../../../../../selectors/deviations';
import { Props } from './HeroPreview';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags';

type StateProps = Pick<Props, 'coverDeviation'>;
type DispatchProps = {};
type OwnProps = Without<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const coverDeviation = getCoverDeviation(state);
  const coverDeviationidOffsetY = getCoverDeviationOffsetY(state);
  const reducedHero = flagEnabled(state, 'profile_reduced_hero');
  return {
    coverDeviation,
    coverDeviationidOffsetY,
    reducedHero,
  };
};

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
